"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FormComponent = /*#__PURE__*/function () {
  function FormComponent() {
    var _this = this;
    _classCallCheck(this, FormComponent);
    this.init();
    this.initNetteFormValidation();

    // AJAX FORM SENT
    $.nette.ext("genericFormAjax", {
      before: function before(jqXHR, settings) {
        if ("nette" in settings) {
          $(settings.nette.el).addClass("sending");
        }
      },
      complete: function complete(jqXHR, status, settings) {
        _this._fieldsVisible = false;
        if ("nette" in settings) {
          $(settings.nette.el).removeClass("sending");
        }
      }
    });
  }

  /**
   * Nette Form Validation
   */
  return _createClass(FormComponent, [{
    key: "initNetteFormValidation",
    value: function initNetteFormValidation() {
      Nette.showFormErrors = function (form, errors) {
        var validationType = $(form).attr("data-validationtype");

        // REMOVE ALL ERRORS FROM FORM
        $("label.error", form).removeClass("error");
        $(".error-text", form).remove();
        switch (validationType) {
          case "fields":
            errors.forEach(function (error) {
              var field = $(error.element, form);
              var label = field.parent("label");
              label.addClass("error"); // SET STYLE AS INVALID FIELD

              // ADD ERROR MESSAGE TO FIELD
              label.append("<span class='error-text'>" + error.message + "</span>");
            });
        }
      };
    }
  }, {
    key: "init",
    value: function init() {}
  }]);
}();